import { render } from "./AppFooter.vue?vue&type=template&id=1249f1b5&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=1249f1b5&lang=scss&scoped=true"

import exportComponent from "/Users/dongjoosong/Code/dp7live/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1249f1b5"]])

export default __exports__